const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Tee valintasi tästä.",
  seeAll: "Näytä kaikki",
  clear: "Poista",
  back: "Takaisin",
  save: "Tallenna ",
  close: "Sulje",
  of: "/",
  to: "osoitteeseen ",
  copyrights: "© {date} Bridgestone Solutions. Kaikki oikeudet pidätetään.",
  pageNotFound: "Sivua ei löydy",
  accessDenied: "Pääsy evätty",
  search: "Etsi",
  year: "Vuosi",
  buttons: {
    loading: "Ladataan...",
    export: "Vie",
    delete: "Poista",
    save: "Tallenna",
    cancel: "Peruuta",
    next: "Jatka",
    back: "Takaisin",
    skip: "Ohita",
    send: "Lähetä",
    readNow: "Lue nyt",
    pointsList: "Pisteiden lista",
    clear: "Poista",
    more: "Lisää",
    close: "Sulje",
    reportError: "Ilmoita virheestä",
    accept: "Hyväksyä",
    download: "Lataa",
    downloadAll: "Lataa kaikki",
    selectAll: "Valitse kaikki",
    deselectAll: "Poista valinta",
    downloadSelection: "Lataa valitut",
    dealerInfoDownload: "Lataa",
    toTheBasket: "Koriin",
    toOrderDelivery: "Jatka toimitusosoitteeseen",
    discover: "Tutustu",
    newAddress: "Luo uusi toimitusosoite",
    selectAddressBtn: "Valitse toimitusosoite",
    toOrderSummary: "Tilauksen yhteenvetoon",
    placeOrder: "Sitova tilaus",
    toDashboard: "Etusivulle",
    newOrder: "Uusi tilaus",
    userOrders: "Tilauksiisi",
    toSearch: "Haku",
    select: "Valitse",
    moreCustomerNumbers: "+ LISÄÄ ASIAKASNUMEROITA",
    loadMore: "Lataa lisää",
    toStaffDashboard: "Hallintapaneeliin",
    toQuiz: "Kyselyyn",
    vouchers: "Kupongit",
    exchangeVoucher: "Lunasta kuponkikoodi",
    confirm: "Vahvista",
    sharePoints: "Jaa pisteitä",
    create: "Luo",
    update: "Päivitä",
    toBDrive: "B-Driveen",
    preview: "Esikatselu",
    clickHere: "Näytä tiedot",
    setFilters: "Aseta <b>enintään yksi suodatin saraketta kohden</b>",
    all: "Kaikki",
  },
  tooltips: {
    info: "Tarvitsetko apua? +358 207 936 200",
  },
  confirmation: {
    header: "Vaadittu vahvistus",
    message: "Haluatko poistaa tämän tietueen?",
  },
  nav: {
    consents: "Suostumukset",
    dashboard: "Etusivu",
    accountDashboard: "Hallintapaneeli",
    account: "Oma Profiili",
    mailbox: "Saapuneet-kansio",
    singleMailbox: "Viestit",
    stammdaten: "Perustiedot",
    news_feeds: "Uutiset",
    pointsOverview: "Pistenäkymä",
    rewardsOverview: "Pistenäkymä",
    about: "Noin BS Plus",
    service_number: "Yhteys palveluun",
    shop: "Palkintokauppa",
    salesPromotions: "Myynninedistämiset",
    promotions: "Oma tili",
    shopCategory: "Palkintokauppa",
    productDetails: "Tuotetiedot",
    userOrders: "Käyttäjän tilaukset",
    shoppingCart: "Ostoskori",
    orderDelivery: "Toimitusosoite",
    orderSummary: "Tilauksen yhteenveto",
    orderComplete: "Tilaus valmis",
    text_page: "Staattinen sivu",
    staff: "Palvelun hallintapaneeli",
    onlineTrainings: "Verkkokoulutukset",
    trainings: "Koulutukset",
    training: "Koulutus",
    trainingForm: "Koulutuslomake",
    staffVouchers: "Kupongit",
    wholesalerVouchers: "Kupongit",
    brochure_prices: "Hinnastot ja esitteet",
    investment: "Investointituki",
    media: "Media",
    medias: "Media",
    contact_service: "Yhteystiedot ja palvelu",
    productInfo: "TUOTETIEDOT",
    bDrive: "Tuotekuvat",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Osallistumise ehdot",
    first_stop: "Bridgestone-rengastakuu",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Etusivu",
    accountDashboard: "Hallintapaneeli",
    account: "Oma Profiili",
    mailbox: "Saapuneet-kansio",
    singleMailbox: "Viestit",
    stammdaten: "Perustiedot",
    news_feeds: "Uutiset",
    pointsOverview: "Pistenäkymä",
    rewardsOverview: "Pistenäkymä",
    about: "Noin BS Plus",
    service_number: "Yhteys palveluun",
    shop: "Palkintokauppa",
    salesPromotions: "Myynninedistämiset",
    promotions: "Oma tili",
    shopCategory: "Palkintokauppa",
    productDetails: "Tuotetiedot",
    userOrders: "Käyttäjän tilaukset",
    shoppingCart: "Ostoskori",
    orderDelivery: "Toimitusosoite",
    orderSummary: "Tilauksen yhteenveto",
    orderComplete: "Tilaus valmis",
    staff: "Palvelun hallintapaneeli",
    onlineTrainings: "Verkkokoulutukset",
    trainings: "Koulutukset",
    training: "Koulutus",
    trainingForm: "Koulutuslomake",
    staffVouchers: "Kupongit",
    wholesalerVouchers: "Kupongit",
    brochure_prices: "Hinnastot ja esitteet",
    investment: "Investointituki",
    media: "Media",
    medias: "Media",
    contact_service: "Yhteystiedot ja palvelu",
    productInfo: "TUOTETIEDOT",
    bDrive: "Tuotekuvat",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Osallistumise ehdot",
    first_stop: "Bridgestone-rengastakuu",
    payouts: "Payouts",
},
  menu: {
    account: "Oma Profiili",
    plus: 'Noin Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Soutien à la vente",
    mailbox: "Saapuneet-kansio",
    about: "Noin BS Plus",
    trainingAndCourses: "Formations et cours",
    externalTraining: "Formations externes",
    productInfo: "Informations sur les produits",
    productBrochures: "Brochures sur les produits",
    priceLists: "Hinnastot",
    price: "Pricat",
    complaintForm: "Formulaire de réclamation",
    sales_support: "Soutien à la vente",
    contact_service: "Yhteystiedot ja palvelu",
    logOut: "Kirjaudu ulos",
    news: "Uutiset",
    news_feeds: "Uutiset",
    service_number: "Yhteys palveluun",
    salesPromotions: "Myynninedistämiset",
    shop: "Kauppa",
    onlineTrainings: "Verkkokoulutukset",
    trainings: "Koulutukset",
    brochure_prices: "Hinnastot ja esitteet",
    media: "Media",
    medias: "Media",
    stammdaten: "Perustiedot",
    preislisten: "Hinnastot",
  },
  validation: {
    requiredField: "Pakollinen kenttä",
  },
  sortBy: {
    default: "Lajittele",
    desc: "Lajittele: Uusimmat",
    asc: "Lajittele: Vanhimmat",
    name: "Nimi",
    date: "Päivämäärä",
    choiceBy: "Lajittele",
  },
  month: {
    1: "tammikuu",
    2: "helmikuu",
    3: "maaliskuu",
    4: "huhtikuu",
    5: "toukokuu",
    6: "kesäkuu",
    7: "heinäkuu",
    8: "elokuu",
    9: "syyskuu",
    10: "lokakuu",
    11: "marraskuu",
    12: "joulukuu"
  },
};


export default {
  messages,
};
